// import store from "../AppRedux/store";
import { storeDataset, storeDatasetField } from "../AppOwnState";
import { pageServiceInstance, authServiceInstance, userMenuStorageKey, apiRoot } from "./globals";
import { mergeObjectDataset, mergeArrayDataset, showAppBusy, hideAppBusy } from "../AppOwnState/ownStateActions";
import { startOfToday } from "date-fns";
import { endOfToday } from "date-fns/esm";
import { funcs, dyadicFuncExecutor, IFTRUE, IFFALSE } from "./funcExecutor";
import { GPSLocation, ShowAppMenu, ShowAppNotification, ShowDialog, ShowSnackBar } from "./globalFunctions";
import StorageService from "../Services/storageService";
import deepmerge from "deepmerge";
import { ownStore } from "../AppOwnState/ownState";

export async function _loadProcDataToDataSet(serverDataset, eventInfo, callBackFunction, refData) {

    if (serverDataset && eventInfo) {
        if(eventInfo.ignoreempty && 
            (typeof serverDataset.length !== "undefined") && 
             serverDataset.length <=0 ) return; 
        let dataSetName = GetControlPropertyFromStoreOrRefData(eventInfo.dset, refData);
        if (dataSetName) {
            if (eventInfo.column && serverDataset?.length > 0) { //Select JSON Data stored in a Column in Dataset; Check the PopupLayout Info Scaffold JSON; It returns the whole dataset; But we need only JSON stored in layoutinfo column
                let columnValue = serverDataset[eventInfo?.row ?? 0][eventInfo.column];
                if (!columnValue) return;
                try {
                    serverDataset = JSON.parse(columnValue);
                }
                catch {
                    return;
                }
            }
            if (typeof eventInfo.row !== undefined && serverDataset.length > eventInfo.row) {
                let rowValue = serverDataset[eventInfo.row];
                serverDataset = rowValue;
            }
            let storeDataSet = ownStore.getState(dataSetName);
            let currentDataSet = storeDataSet;
            if (eventInfo.section && currentDataSet) currentDataSet = currentDataSet[eventInfo.section];    //If section name is provided in event consider it as object of multiple datasets; usually for popups
            // let
            //  dstr1 = JSON.stringify(currentDataSet),
                // dstr2 = JSON.stringify(serverDataset);  //Removed => Just to compare the exisiting Redux Object and new Object; Why shuld we change state if no changes

            // if (dstr1 !== dstr2) {
                if (eventInfo.section) {
                    if (dataSetName === "local") {
                        let dstr2 = JSON.stringify(serverDataset); 
                        localStorage.setItem(eventInfo.section, dstr2);
                    }
                    else if (dataSetName === "session") {
                        let dstr2 = JSON.stringify(serverDataset); 
                        sessionStorage.setItem(eventInfo.section, dstr2);
                    }
                    else {
                        if (dataSetName === "popupinfo") { //If a new popup added, just add a history to enable back click
                            window.history.pushState({}, window.location.hash);
                        }
                        ownStore.dispatch(storeDataset( //Redux
                            {
                                dataSetName: dataSetName,
                                data: { ...storeDataSet, ...{ [eventInfo.section]: serverDataset } }
                            }
                        ));
                    }
                }
                else {

                    ownStore.dispatch(storeDataset( //Redux
                        {
                            dataSetName: dataSetName,
                            data: serverDataset
                        }
                    ));
                }
            //}

            if (callBackFunction) callBackFunction(serverDataset);
        }

    }
}

export function SetCreateDataSet(dataInfo, dataObject, refData) {
    if (dataInfo) {
        let dataSetName = GetControlPropertyFromStoreOrRefData(dataInfo.dset, refData);
        ownStore.dispatch(storeDataset( //Redux
            {
                dataSetName: dataSetName,
                data: dataObject
            }
        ));
    }
}

export function MergeDataSet(dataInfo, dataObject, refData) {
    if (dataInfo) {
        let dataSetName = GetControlPropertyFromStoreOrRefData(dataInfo.dset, refData);
        ownStore.dispatch(mergeObjectDataset( //Redux
            {
                dataSetName: dataSetName,
                data: dataObject
            }
        ));
    }
}

export function DeepMergeDataSet(dataInfo, sourceObject, dataObject, refData) {
    if (dataInfo) {
        dataObject = dataObject ?? {};
        let dataSetName = GetControlPropertyFromStoreOrRefData(dataInfo.dset, refData);
        let mergedObject = deepmerge((sourceObject ?? {}), dataObject);
        ownStore.dispatch(storeDataset( //Redux
            {
                dataSetName: dataSetName,
                data: mergedObject
            }
        ));
    }
}

export function MergeDataSetArray(dataInfo, dataObject, index, mode, refData) {
    if (dataInfo) {
        let dataSetName = GetControlPropertyFromStoreOrRefData(dataInfo.dset, refData);

        ownStore.dispatch(mergeArrayDataset( //Redux
            {
                dataSetName: dataSetName,
                data: dataObject,
                index: index, 
                mode : mode
            }
        ));
    }
}

export function SetCreateDataSetField(dataInfo, refData) {
    if (dataInfo) {
        let dataSetName = GetControlPropertyFromStoreOrRefData(dataInfo.dset, refData);

        let originalData = dataInfo.data;
        let fieldName = dataInfo.fieldname;
        if (dataInfo.fieldname?.includes(".")) {    //Handling deep value changing
            let fieldArrays = dataInfo.fieldname.split(".");
            if (fieldArrays.length > 0) {
                originalData = ownStore.getState(dataSetName)[fieldArrays[0]];
                originalData = JSON.stringify(originalData); //To prevent direct mutation to the Redux
                originalData = JSON.parse(originalData); //To prevent direct mutation to the Redux
                // if (Array.isArray(originalData))
                //     originalData = [...[], ...originalData];
                // else
                //     originalData = { ...{}, ...originalData };
                let deepValue = originalData;
                let i = 1;
                for (; i < fieldArrays.length - 1; i++) {
                    deepValue = deepValue[fieldArrays[i]];
                }
                fieldName = fieldArrays[0];
                deepValue[fieldArrays[i]] = dataInfo.data;
            }
        }

        ownStore.dispatch(storeDatasetField( //Redux
            {
                dataSetName: dataSetName,
                fieldName: fieldName,
                data: originalData
            }
        ));
    }
}

export function objectMatchAll(dataset, verifyArgs, satisfy, stringComparison = "equals", stringIgnoreCase = false) { //Verify single Object value pairs against another single Object and returns true if all property values match 
    let assertedMatches = [];
    if (verifyArgs) {
        Object.keys(verifyArgs).forEach(item => {
            let firstValue = GetControlPropertyFromStoreOrRefData(item, dataset);
            let secondValue = GetControlPropertyFromStoreOrRefData(verifyArgs[item], dataset);
            if (stringIgnoreCase === true) {
                firstValue = (firstValue ?? "").toLowerCase();
                secondValue = (secondValue ?? "").toLowerCase();
            }
            assertedMatches.push(
                stringComparison === "contains" ?
                    (firstValue?.includes(secondValue))
                    : (firstValue === secondValue)
            );
        });
    }
    let isAllMatched =
        satisfy === "any" ? assertedMatches.some(t => t === true)
            : assertedMatches.every(t => t === true);
    return isAllMatched;
}

async function verifyDatasetAgainstMultipleValues(dataset, verifyArgs){

    let isMatchedException = objectMatchAll(dataset, { "[this.type]": "FactsInternalException" }, "any");

    if (isMatchedException) {
        ShowSnackBar("error", dataset?.description ?? "Some unknown error happened!")
        return true;
    }

    let shouldHaltExecution = false;

    let isAllMatched = objectMatchAll(dataset, verifyArgs?.ref, verifyArgs?.satisfy);

    if (isAllMatched && verifyArgs?.whenmatch) {
        await ExecuteLayoutEventMethods(verifyArgs?.whenmatch, dataset);
        if(verifyArgs?.halton === "match" )shouldHaltExecution = true;
    }
    if (!isAllMatched && verifyArgs?.whenunmatch) {
        await ExecuteLayoutEventMethods(verifyArgs?.whenunmatch, dataset);
        if(verifyArgs?.halton === "unmatch") shouldHaltExecution = true;
    }
    return shouldHaltExecution;

}

function getProcessedArgsWithGeoLocation(args, refData) {
    let mProcessedArgs = getProcessedArgs(
        {
            geolat: "[local.devloc.lat]",
            geolong: "[local.devloc.long]",
            ...args
        }
        , refData);
    return mProcessedArgs;
}
async function dsFiller(dataPoint, refData, result_type) {
    if (pageServiceInstance) {
        let resolvedArgs = GetControlPropertyFromStoreOrRefData(dataPoint?.args?.args, refData);

        let sProcessedArgs = getProcessedArgsWithGeoLocation(resolvedArgs, refData);
        let controllerName = GetControlPropertyFromStoreOrRefData(dataPoint?.args?.controller, refData) ; 
        if(!controllerName) controllerName = "proc"; 
        //Offline Access
        let offlineAccess = dataPoint?.args?.offline; 
        //Offline Access
        let sServerDataSet = await pageServiceInstance.loadData(dataPoint?.args?.proc, sProcessedArgs, result_type, controllerName, offlineAccess);

        if ( await verifyDatasetAgainstMultipleValues(sServerDataSet, dataPoint?.args?.verify)) {
            ownStore.dispatch(hideAppBusy());
            return "FactsError";
        }
        return sServerDataSet;
    }
    return undefined;
}
export async function ExecuteLayoutEventMethods(eventData, refData, callBackFunction = null, secondaryCall = false) {
    let eData = GetControlPropertyFromStoreOrRefData(eventData, refData);
    if (typeof eData == "string") eData = JSON.parse(eData);
    if (eData) {
        // store.dispatch(showAppBusy());

        if (eData[0]?.exec !== "hideloader" && (!secondaryCall)) ownStore.dispatch(showAppBusy());

        for (let dataPoint of eData) {
            dataPoint = GetControlPropertyFromStoreOrRefData(dataPoint, refData);
            if (Array.isArray(dataPoint)) {
                await ExecuteLayoutEventMethods(dataPoint, refData, null, true); 
                // for (let childDPoint of dataPoint) {
                //     if (await executeEventDataPoint(childDPoint, refData, callBackFunction) === "HALT") {
                //         return;
                //     }
                // }
            }
            else {
                if (await executeEventDataPoint(dataPoint, refData, callBackFunction) === "HALT")
                    return;
            }
        }
        ownStore.dispatch(hideAppBusy());

    }

}

async function executeEventDataPoint(dataPoint, refData, callBackFunction) {
    switch (dataPoint?.exec) {
        case "filldataset":
            let sServerDataSet = await dsFiller(dataPoint, refData);
            if (typeof sServerDataSet !== "undefined") {
                if (sServerDataSet === "FactsError") return "HALT";
                let fillDsArgs = getProcessedDynamic(dataPoint?.args, refData);
                if(dataPoint?.args?.argsdset) //if argsdset is specified store the args to that dataset; JFF :D
                    SetCreateDataSet({"dset" : dataPoint?.args?.argsdset},
                        (dataPoint?.args?.noprocessargsdset? dataPoint?.args?.args :  fillDsArgs?.args), refData); 

                await _loadProcDataToDataSet(sServerDataSet, fillDsArgs, callBackFunction, refData);
            }
            break;
        case "fillreport":
            let rServerDataSet = await dsFiller(dataPoint, refData, "report");
            if (typeof rServerDataSet !== "undefined") {
                if (rServerDataSet === "FactsError") return "HALT";
                let fillRptArgs = getProcessedDynamic(dataPoint?.args, refData);
                await _loadProcDataToDataSet(rServerDataSet, fillRptArgs, callBackFunction, refData);
            }
            break;
        case "fillmultidataset":
            // if (pageServiceInstance) {
            // let mProcessedArgs = getProcessedArgsWithGeoLocation(dataPoint?.args?.args, refData);
            // let mServerDataset = await pageServiceInstance.loadData(dataPoint?.args?.proc, mProcessedArgs, "multi");

            // if (verifyDatasetAgainstMultipleValues(mServerDataset, dataPoint?.args?.verify)) {
            //     store.dispatch(hideAppBusy());
            //     return;
            // }
            let mServerDataset = await dsFiller(dataPoint, refData, "multi");
            if (mServerDataset) {
                if (mServerDataset === "FactsError") return "HALT";
                for (let mdset of (dataPoint?.args?.dsets ?? [])) {
                    let fillMDsArgs = getProcessedDynamic(mdset, refData);
                    await _loadProcDataToDataSet(mServerDataset[mdset?.table],
                        {
                            "dset": fillMDsArgs?.name,
                            "proc": dataPoint?.args?.proc,
                            "column": fillMDsArgs?.column,
                            "row": fillMDsArgs?.row,
                            "section": fillMDsArgs?.section
                        }, callBackFunction, refData);
                }
            }
            break;
        case "setdataset":
            // store.dispatch(showAppBusy());
            let processedArgsData = getProcessedDynamic(dataPoint?.args?.data, refData, dataPoint?.args?.nodeepprocess);

            SetCreateDataSet(dataPoint?.args, processedArgsData, refData);
            // store.dispatch(hideAppBusy());
            break;
        case "invalidate":
            // store.dispatch(showAppBusy());
            for(let nds of dataPoint?.args?.datasets){
                SetCreateDataSet({dset: nds }, null);
            }
            // store.dispatch(hideAppBusy());
            break;
        case "setlocal":
                // store.dispatch(showAppBusy());
                let processedArgsDataLocal = getProcessedDynamic(dataPoint?.args?.data, refData);
                let lKeyName = GetControlPropertyFromStoreOrRefData(dataPoint?.args?.key, refData);

                localStorage.setItem(lKeyName, JSON.stringify(processedArgsDataLocal) );  
                // store.dispatch(hideAppBusy());
                break;
        case "mergedataset":
            // store.dispatch(showAppBusy());
            let processedArgsData2 = getProcessedDynamic(dataPoint?.args?.data, refData);
            MergeDataSet(dataPoint?.args, processedArgsData2, refData);
            // store.dispatch(hideAppBusy());
            break;
        case "deepmergedataset":
            // store.dispatch(showAppBusy());
            let processedArgsDataSourceDeep = getProcessedDynamic(dataPoint?.args?.data1, refData);
            let processedArgsDataDeep = getProcessedDynamic(dataPoint?.args?.data2, refData);
            DeepMergeDataSet(dataPoint?.args, processedArgsDataSourceDeep, processedArgsDataDeep, refData);
            // store.dispatch(hideAppBusy());
            break;
        case "setdatasetfield":
            let processedArgsData3 = getProcessedArgs(dataPoint?.args, refData);

            SetCreateDataSetField(processedArgsData3, refData);
            break;
        case "mergedatasetarray":
            // store.dispatch(showAppBusy());
            let processedArgsData4 = getProcessedDynamic(dataPoint?.args?.data, refData);
            let curInde = GetControlPropertyFromStoreOrRefData(dataPoint?.args?.index, refData);

            MergeDataSetArray(dataPoint?.args, processedArgsData4, curInde, dataPoint?.args?.mode, refData);
            // store.dispatch(hideAppBusy());
            break;
        case "validatedataset":
            if (await verifyDatasetAgainstMultipleValues(refData, dataPoint?.verify)) {
                ownStore.dispatch(hideAppBusy());
                return 'HALT';
            }
            break;
        case "logout":
            authServiceInstance.logout();
            break;
        case "showloader":
            ownStore.dispatch(showAppBusy());
            break;
        case "hideloader":
            ownStore.dispatch(hideAppBusy());
            break;
        case "showdialog":
            let processedDialogData = getProcessedDynamic(dataPoint?.args, refData, true);

            let dialBtn1Prop = processedDialogData?.btn1 ? {
                chld: processedDialogData?.btn1,
                props: {
                    whenclick: processedDialogData?.btn1whenclick
                }
            } : undefined;
            let dialBtn2Prop = processedDialogData?.btn2 ? {
                chld: processedDialogData?.btn2,
                props: {
                    whenclick: processedDialogData?.btn2whenclick
                }
            } : undefined;
            ShowDialog(processedDialogData?.title, processedDialogData?.description,
                dialBtn1Prop, dialBtn2Prop);
            break;
        case "showmenu":
            let menuItems = null;

            if (typeof dataPoint?.args?.items === "string")
                menuItems = GetControlPropertyFromStoreOrRefData(dataPoint?.args?.items, refData);
            else if (Array.isArray(dataPoint?.args?.items))
                menuItems = getProcessedArray(dataPoint?.args?.items, refData);
            menuItems &&
                ShowAppMenu(refData?.controlid, menuItems, dataPoint?.args?.layout, dataPoint?.args?.title, refData)
            break;
        case "showsnackbar":
            let snackArgs = getProcessedDynamic(dataPoint?.args, refData);

            ShowSnackBar(snackArgs?.type, snackArgs?.message);
            break;
        case "shownotification":
            ShowAppNotification(dataPoint?.args);
            break;
        case "eval":
            eval(dataPoint?.js);
            break;
        case "alert":
            let alertData = getProcessedDynamic(dataPoint?.input, refData);
            alert(JSON.stringify(alertData)); 
            break;

        case "debuglog":
            let logData = getProcessedDynamic(dataPoint?.input, refData);
            console.log(logData);
            break;
        case "collectgeo" : 
            await GPSLocation(dataPoint?.args); 
            break; 
        case "logtime" : console.log(dataPoint?.prefix + " " +  Date().toLocaleString()); break;
        case "downloadfile" : 
            let downloadArgs = getProcessedDynamic(dataPoint?.args, refData);
            let link = document.createElement('a');
            link.setAttribute('href',downloadArgs?.prefix + downloadArgs.filedata);
            link.setAttribute('download', downloadArgs?.filename);
            document.body.appendChild(link);
            
            link.click();
            document.body.removeChild(link);
            break;
        // case "showpopup":
        //     await ExecuteLayoutEventMethods(
        //         [
        //             {
        //                 "exec": "filldataset",
        //                 "args": {
        //                     "proc": "PWA.LoadLayout",
        //                     "column": "layoutinfo",
        //                     "dset": "popupinfo",
        //                     "section": dataPoint?.args?.section,
        //                     "args": {
        //                         "doctype": dataPoint?.args?.doctype,
        //                         "docno": dataPoint?.args?.docno
        //                     }
        //                 }
        //             }
        //         ]);
        //     break;
        default:

    }
    return "";
}

export function getProcessedDynamic(args, refData, noDeepProcessing, fromRenderer) {
    if (Array.isArray(args)) return getProcessedArray(args, refData, noDeepProcessing, fromRenderer);
    else if(typeof args === "object") return getProcessedArgs(args, refData, noDeepProcessing, fromRenderer);
    else return GetControlPropertyFromStoreOrRefData(args, refData);
}

export function getProcessedArgs(args, refData, noDeepProcessing, fromRenderer) {
    if (!args) return null;
    if (args instanceof Date) return args;
    let processedArgs = {};

    let argsToProcess = GetControlPropertyFromStoreOrRefData(args, refData);
    if (!noDeepProcessing && argsToProcess && typeof argsToProcess === "object") {
        if (!(argsToProcess?.noinitialprocess && fromRenderer)) {
            Object.keys(argsToProcess).forEach(item => {
                if (typeof argsToProcess[item] === "string")
                    processedArgs = { ...processedArgs, ...{ [item]: GetControlPropertyFromStoreOrRefData(argsToProcess[item], refData) } };
                else if (Array.isArray(argsToProcess[item]))
                    processedArgs = { ...processedArgs, ...{ [item]: getProcessedArray(argsToProcess[item], refData, undefined, fromRenderer) } };
                else if (typeof argsToProcess[item] === "object")
                    processedArgs = { ...processedArgs, ...{ [item]: getProcessedArgs(argsToProcess[item], refData, undefined, fromRenderer) } };
                else
                    processedArgs = { ...processedArgs, ...{ [item]: argsToProcess[item] } };

            });
            return processedArgs;

        }
    }
    return argsToProcess;
}

function getProcessedArray(args, refData, noDeepProcessing, fromRenderer) {
    let processedArgs = [];
    if (!args) return null;
    if (!args.forEach) return args;
    if (noDeepProcessing) return args;
    args.forEach(item => {
        if (typeof item === "string")
            processedArgs = [...processedArgs, GetControlPropertyFromStoreOrRefData(item, refData)];
        else if (typeof item === "object") //Todo: Need to consider Array Later
            processedArgs = [...processedArgs, getProcessedArgs(item, refData, undefined, fromRenderer)];
        else
            processedArgs = [...processedArgs, item];
    });
    return processedArgs;

}

export function GetControlPropertyFromStoreOrRefData(propertyString, refData = null) { //To resolve  property in bracket to select from Redux State Property
    let currentState = propertyString;
    if (propertyString && propertyString.startsWith && propertyString.startsWith("[") && propertyString.endsWith("]")) {
        // propertyString = propertyString.replace(" ", "")
        // let prop = propertyString.replace("[", "").replace("]", "")
        let prop = propertyString.slice(1, propertyString.length - 1);
        if (prop) {
            prop = _resolveInnerBinding(prop, refData);
            let funcDetails = [];

            funcs.forEach(t => {
                let currentFuncIndex = 0;
                do {
                    currentFuncIndex = prop.indexOf(t, currentFuncIndex + 1);
                    if (currentFuncIndex > 0) {
                        funcDetails.push({ "index": currentFuncIndex, "oper": t });
                    }
                } while (currentFuncIndex > 0);
            });

            funcDetails = funcDetails.sort((a, b) => a.index - b.index).map((t, index) => {
                return { ...t, "index": index }
            });

            // let funcDetails = funcs.map((t) => {

            //     return { "index": prop.indexOf(t), "oper": t };
            // }).filter(t => t.index > 0).sort(t => t.index).map((t, index) => {
            //     return { ...t, "index": index }
            // });
            if (funcDetails.length > 0) { //Bind string contains a  Formula, Find it and process them
                // let propToSplit = "";
                funcDetails.forEach(t => {
                    prop = prop.split(t.oper).join("*^*");
                });
                let propList = prop.split("*^*");

                let aggregate = _getBindData(propList[0], currentState, refData);
                let haveCondition = false;
                for (let i = 0; i < funcDetails.length; i++) {
                    let t = funcDetails[i];
                    let secondValue = _getBindData(propList[t.index + 1], currentState, refData);
                    if (t.oper === IFTRUE) { //iftrue function
                        if (aggregate === true) { //If the value upto here results to => true
                            aggregate = secondValue;    //Set the second value as the value; That's the result
                            haveCondition = true;   //Setting this to true to prevent (iffalse) to execute
                        }
                        else { //If the aggregate is not true 
                            i = funcDetails.findIndex((t, j) => j > i && t.oper === IFFALSE);  //Finding the next iffalse function index that comes after the current ifftrue function (This is to prevent considering the secondValue of iftrue function)
                            if (i < 0) break; //if the iffalse function is not found; i.e., the index is -1, just break the loop
                            else i--;  //if the iffalse function is found, minus 1 to make sure the iffalse function will be executed
                        }

                    }
                    else if (t.oper === IFFALSE) { //iffalse function
                        if (haveCondition) break; //if the iftrue condition is already satisfied, no need to execute the iffalse function
                        if (aggregate === false) aggregate = secondValue; //if the aggregate value is false, take the secondValue as result

                    }
                    else aggregate = dyadicFuncExecutor(t.oper, aggregate, secondValue); //Do the other functions
                }
                currentState = aggregate;

            }
            else { //Binding string doesnt have formula, so just process it
                currentState = _getBindData(prop, currentState, refData);
            }
        }
    }

    if (currentState === undefined) currentState = null;
    return currentState;
}

function _resolveInnerBinding(prop, refData) {
    let innerBindStart = prop.indexOf("["),
        innerBindEnd = prop.indexOf("]");
    if (innerBindStart >= 0 && innerBindEnd > innerBindStart) {
        let innerBind = prop.slice(innerBindStart, innerBindEnd + 1);
        let bindData = GetControlPropertyFromStoreOrRefData(innerBind, refData);
        prop = prop.replace(innerBind, bindData);
        prop =  _resolveInnerBinding(prop, refData); 
    }
    return prop;
}
function _getBindData(prop, currentState, refData) {

    let propArray = prop.split(".");
    let dataMode = "state";

    switch (propArray[0]) {
        case "this":  //If binding string start from this, use RefData i.e, local data send by the request
            currentState = refData;
            break;
        case "func": break;  //If binding string is a value function, no need to get the state data, it will be calculate in following lines
        case "local": //get localStorage data(Treat JSON Parse)
            if (propArray.length > 1) {
                currentState = localStorage[propArray[1]] && JSON.parse(localStorage[propArray[1]]);
                propArray[1] = "local";
            }
            break;
        case "session": //get sessionStorage data (Treat JSON Parse)
            if (propArray.length > 1) {
                currentState = JSON.parse(sessionStorage[propArray[1]]);
                propArray[1] = "session";
            }
            break;
        case "serviceurl" : 
            propArray[1] = "serviceurl";
            currentState = apiRoot;
            break;
        case "lastpopup" : 
            propArray[1] = "lastpopup";
            currentState = getLastPopupKey();
            break;
        case "url": //get url routes
            if (propArray.length > 1) {
                let urlArray = window.location.hash.split("/");
                let urlChunkIndex = parseInt(propArray[1]);
                if (urlChunkIndex) {
                    currentState = urlArray[urlChunkIndex];
                    propArray[1] = "url";
                }
            }
            else
                currentState = window.location.href;
            break;
        case "raw":   //Raw Text
            dataMode = "raw";
            propArray.shift(); //Rejoin the string excluding the raw keyword and return it
            currentState = propArray.join(".").replace("{chrdot}", ".");
            break; //If this is raw string no need to get a state, instead it will be processed by the loop
        default: //All other, get state from Redux state
            currentState = getReduxState(); 
             
    }
    // if (propArray[0] !== "func") { //The binding is not from a Value function (like today)
    //     currentState = propArray[0] === "this" ? refData : store.getState();
    // }
    if (dataMode !== "raw") {
        for (let propItem of propArray) {
            if (propItem === "this" || propItem === "local" || propItem === "session" || 
                propItem === "url" ||  propItem === "serviceurl" ||  propItem === "lastpopup" ) continue; //If binding string starts with a pointer, just ignore the first section
            if (propItem === 'func') {
                dataMode = 'func';
                continue;
            }

            else if (dataMode === "func") {
                currentState = _getFuncValue(propItem);
                break;
            }
            else if (propItem && currentState) {
                currentState = currentState[propItem];
            }
        }
    }
    return currentState;
}


function getReduxState(){
    return ownStore.getFullState(); //To CHECK
}

function _getFuncValue(propItem) {
    switch (propItem) {
        case "null": return null;
        case "true" : return true; 
        case "false" : return false; 
        case "undefined" : return undefined; 
        case "emptystring" : return ""; 
        
        case "today":
            return new Date();
        case "todaystarttime":
            var dt = startOfToday()
            return dt;
        case "todayendtime":
            var dt1 = endOfToday()
            return dt1;
        case "emptyarray":
            return [];
        case "emptyobject":
                return {};
              
        default:
            return null;
    }
}


export function ChangePageDataSetState(datasets) {  //Join Redux States to single object; To avoid calling local setState multiple times; Currently implemented in  factsTaskList component
    let dstate = {};
    for (let dset of datasets) {
        dstate = { ...dstate, ...{ [dset]: ownStore.getState(dset) } };
    }
    return dstate;
}

function getLastPopupKey (){
    let pInfo = ownStore.getState("popupinfo");
    if(pInfo) return Object.keys(pInfo).pop();
    return null; 
}

export async function RemoveLastDialog(e) {
    let pInfo = ownStore.getState("popupinfo");
    if(pInfo) { 
        let lastKey = Object.keys(pInfo).pop();
        if (lastKey) {
            if (pInfo[lastKey].appbar?.whenbackclick) {
                await ExecuteLayoutEventMethods(pInfo[lastKey].appbar?.whenbackclick);
            }
            else {
                await ExecuteLayoutEventMethods(
                    [
                        {
                            "exec": "setdatasetfield",
                            "args": {
                                "dset": "popupinfo",
                                "fieldname": lastKey,
                                "data": null
                            }
                        }]);
            }
            return;
        }
    }
    // alert(e.currentTarget.location.hash)

    handleRouting(e.currentTarget.location.hash.split("/")[1]);
     
}

export async function handleRouting(docNoFromRoute) { //Repeated from AuthorizedCOmponent due to logic change

    let currentPageInfo = ownStore.getState("pageinfo");
    if(currentPageInfo?.whenbackbutton){
        // await ExecuteLayoutEventMethods([{
        //     "exec": "setdataset",
        //     "args": {
        //         "dset": "pageinfo",
        //         "data": currentPageInfo
        //     }
        // }]);
    
        window.history.pushState({}, '')
        await ExecuteLayoutEventMethods(currentPageInfo?.whenbackbutton);
        return; 
    }

    let userMenu = new StorageService().getJsonValue(userMenuStorageKey);
    userMenu = userMenu?.map(t => {
        let actionObj = JSON.parse(t.action);
        t.action = actionObj;
        return t;
    });

    let pageToShow = userMenu?.filter(t => docNoFromRoute === t.permalink);
    if (pageToShow?.length <= 0) {
        pageToShow = userMenu?.filter(t => t.homepage && t.homepage.toLowerCase() === "true");
        window.history.pushState({}, '') //Note: Commented to check Back button not exiting issue
    }
    if (pageToShow?.length > 0) {
        // alert(JSON.stringify(pageToShow[0]?.action));
        // window.location.hash = "#" + pageToShow[0]?.permalink;
        await ExecuteLayoutEventMethods([{
            "exec": "setdataset",
            "args": {
                "dset": "pagemenuinfo",
                "data": pageToShow[0]
            }
        }]);
        await ExecuteLayoutEventMethods(pageToShow[0]?.action);
    }

}